import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses, loadScrollMagic } from "../../utils/siteUtils";
import { Icon } from "../../elements";
import { mobileIs } from "../../utils/siteUtils";
import "./style.scss";
import Swiper from 'swiper';
import gsap from 'gsap';

const Adas = props => {
	const { lang, rendering, fields, page } = props;
  const {	list, paddingAboveTop } = fields;
  const isMobile = mobileIs()
  const isAR = page?.fields?.rtl?.value;
  const swiperEl = useRef(null)
  const swiper = useRef(null)
  const rootNode = useRef()
  const paginationEl = useRef()
  const progressEl = useRef()
  const [currentIndex, setCurrentIndex] = useState(0);

  const buildSwiper = () => {
    const options = {
      watchSlidesProgress: true,
      slidesPerView: isMobile ? 1 : 3,
      spaceBetween: isMobile ? 0 : 60,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: isAR ? ".swiper-button-next" : ".swiper-button-prev",
        prevEl: isAR ? ".swiper-button-prev" : ".swiper-button-next",
      },
      on: {
        slideChange(swiper) {
          let realIndex = swiper.realIndex
          setCurrentIndex(realIndex)
        }
      }
    }
    swiper.current = new Swiper(swiperEl.current, options);
  }

  useEffect(() => {
    let scale = (3 + currentIndex)/list.length
    if(progressEl.current) {
      progressEl.current.style.width = scale * 400 + 'px'
    }
  }, [currentIndex])

  useEffect(() => {
  	if(list.length > 3 && progressEl.current) {
  		progressEl.current.style.width = 3/list.length * 400 + 'px'
  	}
  	let timer = setTimeout(v => {
      buildSwiper()
      clearTimeout(timer)
    }, 100)

    setTimeout(v => {
      let ScrollMagic, controller, scene, tl
      ScrollMagic = loadScrollMagic()
      controller = new ScrollMagic.Controller()
      tl = gsap.timeline()

      for (let i = 0; i < list.length; i++) {
        tl.add(gsap.to(`#item__image_content${list[i].id}`, {
          y: 0,
        }), 1)
        .add(gsap.to(`#item__title${list[i].id}`, {
          y: 0,
          opacity: 1
        }), 1)
        .add(gsap.to(`#item__desc${list[i].id}`, {
          y: 0,
          opacity: 1
        }), 1)
        // .add(gsap.to(`#item__image${list[i].id}`, {
        //   scale: 1.05
        // }), 1)
        .add(gsap.to(paginationEl.current, {
          y: 0,
          opacity: 1
        }), 1)
      }
      
      scene = new ScrollMagic.Scene({
        triggerElement: rootNode.current,
        triggerHook: 0,
        offset: - window.innerHeight / 1.1,
        duration: window.innerHeight * 0.6
      })
      .setTween(tl)
      .addTo(controller)

      return () => {
        scene.destroy(true);
        scene = null;
        controller.destroy(true);
        controller = null;
      };
    }, 200)
  }, [])

  const rootClasses = classNames("c-adas", getOverallSettingsClasses(fields));
  const paginationClass = classNames("pagination-content", `top-${paddingAboveTop?.fields?.key.value}`)
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} ref={rootNode}>
    	<div className="c-adas__swiper" ref={swiperEl}>
        <div className="swiper-wrapper">
          {list && list.map((item, index) => (
            <div className="swiper-slide" key={index}>
              <div className="image-content" id={`item__image_content${item.id}`}>
                <div className="image" style={{ backgroundImage: `url(${item?.fields?.image?.value?.src})` }} id={`item__image${item.id}`} />
              </div> 
              {!isMobile && <RichText tag="div" className="title" field={item?.fields?.pc_title} id={`item__title${item.id}`} />}
              {!isMobile && <RichText tag="div" className="desc" field={item?.fields?.pc_desc} id={`item__desc${item.id}`} />}
              {isMobile && <RichText tag="div" className="title" field={item?.fields?.m_title} id={`item__title${item.id}`} />}
              {isMobile && <RichText tag="div" className="desc" field={item?.fields?.m_desc} id={`item__desc${item.id}`} />}
            </div>
          ))}
        </div>
        <div className={paginationClass} ref={paginationEl}>
          {(isMobile || (!isMobile && list.length > 3)) && <div className="swiper-button-next">
            <Icon name="ArrowBack" className="c-triangle-group__left" />
          </div>}
          <div className="swiper-pagination"></div>
          {(isMobile || (!isMobile && list.length > 3)) && <div className="swiper-button-prev">
            <Icon name="ArrowForward" className="c-triangle-group__right" />
          </div>}
        </div>
        {list.length > 3 && <div className="progress-content">
        	<div className="progress" ref={progressEl}></div>
        </div>}
      </div>
    </div>
  );
};

export default 	Adas;